module.exports = __webpack_public_path__ + "media/images/brand/favicon-08-5311945d4f0a18de233814fb69c379a6.png";